import { baseQuery } from '../baseQuery';

export const getCheckLostJobs = async () => {
  const data = await baseQuery('check-lost-jobs');

  return data;
};
